/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type AddCollaboratorBadRequestErrorCode =
  (typeof AddCollaboratorBadRequestErrorCode)[keyof typeof AddCollaboratorBadRequestErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddCollaboratorBadRequestErrorCode = {
  collaborator_limit_reached: "collaborator_limit_reached",
  cannot_collaborate_with_self: "cannot_collaborate_with_self",
} as const;
